import { ReferenceParser } from "@methodset/calculator-ts";
import { TableWidgetConfiguration, Widget } from '@methodset/application-client-ts';

export class TableWidgetSync {

    public static parser = (widget: Widget): string[] => {
        const configuration = widget.configuration as TableWidgetConfiguration;
        const refs: string[] = [];
        refs.push(...ReferenceParser.extract(configuration.hideId, true));
        refs.push(...ReferenceParser.extract(configuration.rangeId, true));
        return refs;
    }

    public static updater = (widget: Widget, target: string, replacement: string): void => {
        const configuration = widget.configuration as TableWidgetConfiguration;
        configuration.hideId = ReferenceParser.update(configuration.hideId, target, replacement, true);
        configuration.rangeId = ReferenceParser.update(configuration.rangeId, target, replacement, true);
    }

}
